import { ArrowForward as ArrowForwardIcon } from '@mui/icons-material';
import { Controller } from 'react-hook-form';
import { AccordionItemProps, SidebarAccordion } from 'src/components/accordion';
import { InputWidget } from 'src/components/widget';
import { SectionTypes } from 'src/interfaces';
import { lang } from 'src/utils';

import { InputContainer } from '../LayoutEditSidebar.styled';
import { LayoutEditSidebarAccordionProps } from './LayoutEditSidebarAccordion.interface';

export const LayoutEditSidebarAccordion = (
  props: LayoutEditSidebarAccordionProps,
) => {
  const editDrawerMenu: AccordionItemProps[] = [
    {
      label: lang.editLayoutsSidebar.generalDetails,
      content: (
        <InputContainer>
          <Controller
            control={props.formMethods.control}
            name="name"
            rules={{
              required: lang.editLayoutsSidebar.layoutNameRequired,
              maxLength: {
                value: 100,
                message: lang.editLayoutsSidebar.layoutNameMaximum,
              },
            }}
            render={({ field, fieldState }) => (
              <InputWidget
                {...field}
                onChange={(value) => field.onChange((value as string).trim())}
                value={field?.value}
                label={lang.editLayoutsSidebar.layoutName}
                hasError={!!fieldState?.error}
                error={fieldState?.error?.message}
              />
            )}
          />
        </InputContainer>
      ),
      disabledExpand: false,
      hasError: false,
      defaultExpanded: true,
      tooltip: lang.editLayoutsSidebar.sectionDisabledTooltip,
    },
    {
      label: lang.editLayoutsSidebar.defaultLayout,
      onLabelClick: props.onToggleDefaultDrawer,
      content: <div />,
      chevronIcon: <ArrowForwardIcon />,
      disabledExpand: true,
      hasError: false,
      prefixNumber: '1',
      hasCheckIcon: props.isScreensFilled,
      tooltip: lang.editLayoutsSidebar.sectionDisabledTooltip,
    },
    ...(props.sectionTypes?.includes(SectionTypes.SECTION_ROTATION)
      ? [
          {
            label: lang.editLayoutsSidebar.screenRotations,
            onLabelClick: props.onToggleScreenRotationDrawer,
            content: <div />,
            chevronIcon: <ArrowForwardIcon />,
            disabledExpand: true,
            hasError: false,
            disabled: !props.isScreensFilled,
            prefixNumber: '2',
            hasCheckIcon: props.hasScreenRotationEvent,
            tooltip: lang.editLayoutsSidebar.sectionDisabledTooltip,
          },
        ]
      : []),
    ...(props.sectionTypes?.includes(SectionTypes.TAKE_OVER)
      ? [
          {
            label: lang.editLayoutsSidebar.takeOver,
            onLabelClick: props.onToggleTakeoverDrawer,
            content: <div />,
            chevronIcon: <ArrowForwardIcon />,
            disabledExpand: true,
            hasError: false,
            disabled: !props.isScreensFilled,
            prefixNumber: props.sectionTypes?.includes(
              SectionTypes.SECTION_ROTATION,
            )
              ? '3'
              : '2',
            hasCheckIcon: !props.noTakeoverSelected,
            tooltip: lang.editLayoutsSidebar.sectionDisabledTooltip,
          },
        ]
      : []),
  ];

  return <SidebarAccordion items={editDrawerMenu} />;
};
